import React from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Page from 'src/components/Page';
import { Failures } from 'src/utils/constants/failures';
import FailuresCategoriesListTabs from './FailuresCategoriesListTabs';
import Toolbar from './Toolbar';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const FailuresCategoriesView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { tab } = useParams();
  const currentTab = tab || Failures.BILLING;
  
  return (
    <Page className={classes.root} title={t('NAVIGATION.FAILURES')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar currentTab={currentTab} />
          <Box mt={3}>
            <FailuresCategoriesListTabs />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default FailuresCategoriesView;
